// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'monCharacterLimit',
    standalone: false,
})
export class MonCharacterLimitPipe implements PipeTransform {
    transform (word: string, limit?: number | null): string {
        if (!word) {
            return '';
        }
        if (!limit) {
            return word;
        }
        const ext = word.length > limit ? '...' : '';
        return word.substring(0, limit) + ext;
    }
}
